"use strict";

Shopify.theme.jsCustomAccordion = {
    init: function init($section) {
        if ($(window).width() < 769) {
            this.createTabs();
        }
    },
    createTabs: function createTabs() {
        $('.accordion__title').click(function(e) {
            e.preventDefault();
            var $this = $(this);
            if ($this.next().hasClass('show_custom')) {
                $this.next().removeClass('show_custom');
                $this.next().slideUp(350);
                $this.removeClass('active');
            } else {
                $this.closest('.accordion-start').find('.inner').removeClass('show_custom');
                $this.closest('.accordion-start').find('.inner').slideUp(350);
                $this.next().toggleClass('show_custom');
                $this.closest('.accordion-start').find('.accordion__title').removeClass('active');
                $this.toggleClass('active');
                $this.next().slideToggle(350);
            }
        });
    }
};